function copyToClipboard(textToCopy, callback) {
    if (typeof navigator.clipboard == 'undefined') {
        if (typeof Bugsnag !== 'undefined') {
            Bugsnag.notify(new Error('Failed'), function (event) {
                event.addMetadata('failed', { what: 'no clipboard', in: 'copyToClipboard.js' });
            });
        }

        alert(sk_i18n.msgFailedCopyDiscountCode);
        return;
    }

    try {
        navigator.clipboard.writeText(textToCopy).then(function () { callback(); }).catch(function (e) {
            if (typeof Bugsnag !== 'undefined') {
                Bugsnag.notify(e, function (event) {
                    event.addMetadata('failed', { what: 'writeText', in: 'copyToClipboard.js' });
                });
            }

            navigator.clipboard.write([new ClipboardItem({
                'text/plain': new Blob([textToCopy], {type: 'text/plain'})
            })]).then(function () { callback(); }).catch(function (e) {
                if (typeof Bugsnag !== 'undefined') {
                    Bugsnag.notify(e, function (event) {
                        event.addMetadata('failed', { what: 'write', in: 'copyToClipboard.js' });
                    });
                }

                alert(sk_i18n.msgFailedCopyDiscountCode);
                window.location.reload();
            })

        });
    } catch (e) {
        if (typeof Bugsnag !== 'undefined') {
            Bugsnag.notify(e, function (event) {
                event.addMetadata('failed', { what: 'try', in: 'copyToClipboard.js' });
            });
        }
    }
}

function copyToClip(txtToCopy) {
    copyToClipboardWithAlert(txtToCopy);
}

function maskDiscountCode(code) {
    if ('number' == typeof code) {
        code = code.toString();
    }
    
    return code.substring(0, 4) + '********';
}

function copyToClipboardWithAlert(txtToCopy, callback) {
    copyToClipboard(txtToCopy, function() {
        alert(sk_i18n.msgAlertCopy + maskDiscountCode(txtToCopy) + sk_i18n.msgAlertCopyFooter);
        callback();
    });
}

function copyLinkToClipboard() {
    var txtToCopy = 'https://' + document.location.host + document.location.pathname + document.location.search;
    copyToClipboard(txtToCopy, function()  {
        alert(sk_i18n.msgAlertShare + txtToCopy);
    });

}

function copyLinkToClipboardCloseShareModal() {
    var $modal = $('#shareModal');

    $modal.modal('hide');
    $modal.css('display', 'none');

    $('.modal-backdrop').remove();

    copyLinkToClipboard();
}

